import { FaFacebookF, FaInstagram, FaTwitter, FaEnvelope} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="relative z-50 w-full bg-black text-gray-300">
     
      <div className="h-1 w-full bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500"></div>

      
      <div className="max-w-screen-3xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-12">
        
        <div className="text-center md:text-left px-4 md:px-0">
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-3">
            DHEERAM APPAREL CREATIONS
          </h2>
          <p className="text-sm sm:text-base text-gray-400 leading-relaxed max-w-md mx-auto md:mx-0">
            Your go-to fashion destination for bold, street-smart styles that speak confidence. Crafted for the modern rebel.
          </p>
        </div>

        <div className="flex flex-col gap-4 text-center">
          <h3 className="text-lg font-semibold text-white">Quick Links</h3>
         <button  onClick={() => navigate("/contact")} >
          <p className="cursor-pointer hover:text-white transition-all">
            <FaEnvelope className="inline mr-2" />  Contact Us
          </p></button>
        </div>

        
        <div className="text-center">
          <h3 className="text-xl font-semibold text-white mb-4">Follow Us</h3>
          <div className="flex gap-5 text-xl justify-center">
            <FaFacebookF className="hover:text-blue-500 cursor-pointer transition-transform duration-300 hover:scale-110 text-3xl" />
            <FaInstagram className="hover:text-pink-500 cursor-pointer transition-transform duration-300 hover:scale-110 text-3xl" />
            <FaTwitter className="hover:text-sky-400 cursor-pointer transition-transform duration-300 hover:scale-110 text-3xl" />
          </div>
        </div>
      </div>

      
      <div className="bg-gray-900 py-4 text-center text-sm border-t border-gray-800">
        © 2025 <span className="text-white font-medium">DHEERAM APPAREL CREATIONS</span>. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
